import { eventConstants } from "../../../constants/event/event.constants";

/* const defaultState = {
  selectedEvent: 3,
  eventLanguage: "swe"
};
 */
export function event(state = {}, action) {
  switch (action.type) {
    case eventConstants.TOGGLE_EVENT_LANGUAGE:
      return {
        ...state,
        eventLanguage: action.code
      };
    case eventConstants.GET_EVENT_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case eventConstants.GET_EVENT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        eventList: action.eventList,
        eventListTime: Date.now()
      };
    case eventConstants.GET_EVENT_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case eventConstants.GET_EVENT_REQUEST:
      return {
        ...state,
        loading: true
      };
    case eventConstants.GET_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        event: action.event
      };
    case eventConstants.GET_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case eventConstants.GET_EVENT_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case eventConstants.GET_EVENT_SETTINGS_SUCCESS:
    case eventConstants.UPDATE_EVENT_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        eventSettings: action.eventSettings
      };
    case eventConstants.GET_EVENT_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case eventConstants.UPDATE_EVENT_REQUEST:
      return {
        ...state,
        loading: true
      };
    case eventConstants.UPDATE_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        showSaveAlert: true,
        event: action.event
      };
    case eventConstants.UPDATE_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case eventConstants.CREATE_EVENT_REQUEST:
      return {
        ...state,
        loading: true
      };
    case eventConstants.CREATE_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        showSaveAlert: true,
        event: action.event
      };
    case eventConstants.CREATE_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
}
